import { SxProps } from "@mui/material";
import { keyframes } from "@mui/system";
import { ITheme } from "../../utils/theme";

// BoardLayout component styles
export const LayoutContainerStyle = {
  flexWrap: { xs: "nowrap" },
}

export const ColumnStyle = {
  flexShrink: 0,
  backgroundColor: (theme: ITheme) => theme.palette.grey["A250"],
  margin: { sm: "2px" },
}

export const ContentStyle = {
  marginBottom: 2,
}

export const StatusContainerStyle = {
  color: (theme: ITheme) => theme.palette.common.white,
  background: (theme: ITheme) => theme.palette.common.black,
  padding: 0.5,
  marginTop: 1,
  fontWeight: 'bold',
}

// BoardPlate component styles
export const SubBoardContainerStyle = {
  display: "flex",
  padding: "4px 0",
  color: (theme: ITheme) => theme.palette.common.white,
  background: "#525252",
}

export const SubBoardTitleStyle = {
  flexGrow: 1,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: { xs: '0.65rem', md: '0.85rem' }
}

export const PlateContainerStyle = {
  display: "flex",
  padding: "2px 0",
  position: "relative"
}

export const NumberSectionContainerStyle = {
  flex: 1
}

export const NumberSectionStyle = {
  textAlign: "center",
  padding: "2px",
  fontSize: { xs: '0.65rem', md: '0.85rem' }
}

export const PopoverStyle = {
  "& .MuiPopover-paper": {
    borderRadius: 0,
    boxShadow: "none",
  }
}

export const MessageStyle = {
  color: (theme: ITheme) => theme.palette.common.white,
  border: (theme: ITheme) => `solid 2px ${theme.palette.common.black}`,
  background: (theme: ITheme) => theme.palette.blue[500],
  padding: "5px",
}

export const getButtonSectionStyle = (buttonsAmount: number) => ({
  flex: {
    xs: buttonsAmount === 0 ? 0 : buttonsAmount === 1 ? 3 : buttonsAmount === 2 ? 5 : 7,
    md: buttonsAmount === 0 ? 0 : buttonsAmount === 1 ? 2 : buttonsAmount === 2 ? 3 : 5
  },
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  position: "relative",
  overflow: "hidden",
});

export const ButtonStyle = {
  "& > img": {
    mr: '2px',
    display: 'inline-block',
    border: (theme: ITheme) => `solid 1px ${theme.palette.common.white}`,
    width: { xs: '27px', sm: '30px', md: '37px', lg: 'auto' }
  }
}

export const SiteJobSectionContainerStyle = {
  flex: 4,
  textAlign: "center",
  display: "flex"
}

export const SiteJobSectionStyle = {
  margin: "2px",
  padding: "2px",
  flex: 1,
  background: (theme: ITheme) => theme.palette.grey["A50"]
}

export const NameSectionDefaultStyle = {
  padding: "2px",
  fontSize: { xs: '0.65rem', md: '0.85rem' },
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  backgroundColor: "transparent",
  cursor: 'pointer'
}

export const NameSectionBlinkStyle = (borderColor: string, plateColor: string): SxProps => {
  const blink = keyframes`
    0%   { background-color: ${plateColor}00; }
    50%  { background-color: ${plateColor}FF; }
    100% { background-color: ${plateColor}00; }
  `;

  return {
    borderColor,
    animation: `${blink} 3s ease infinite`
  }
};

export const NameSectionContainerStyle = {
  flex: 5,
  overflow: "hidden",
  border: "2px solid",
  borderColor: "transparent",
  backgroundColor: "transparent"
};
